import {Model} from "@vuex-orm/core";

export default class WebsiteBlogCountry extends Model {
    static entity = 'websiteBlogCountry'

    static primaryKey = ['website_blog_id', 'country_id']

    static fields () {
        return {
            website_blog_id: this.attr(null),
            country_id: this.attr(null)
        }
    }
}
